import { PENDING_EVALUATION_TASK_KEY, validEvaluationTaskPath } from './lib/evaluation-task-link'
import { createPinia } from 'pinia'
import { setupLayouts } from 'virtual:generated-layouts'
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { routes } from 'vue-router/auto-routes'

import App from './App.vue'
import { useAuth } from './composables/useAuth'
import { isDynamicImportFetchError, routeChunkReloadKey } from './router-recovery'
import { useUserStore } from './stores/user'

import './style.css'
import './assets/index.css'
import './assets/test-ground.css'
import 'virtual:uno.css'
import '@unocss/reset/normalize.css'
import '@unocss/reset/tailwind.css'
import 'vue-sonner/style.css'

const LOGIN_URL = '/api/auth/login'

// 根路径重定向到评测主页（没有独立的首页页面）
const finalRoutes = [
  { path: '/', redirect: '/test-ground' },
  ...routes,
]

const router = createRouter({
  history: createWebHistory(),
  routes: setupLayouts(finalRoutes),
})

router.onError((error, to) => {
  if (!isDynamicImportFetchError(error)) return
  const key = routeChunkReloadKey(to.fullPath)
  if (sessionStorage.getItem(key)) return
  sessionStorage.setItem(key, '1')
  window.location.assign(to.fullPath)
})

router.afterEach((to, _from, failure) => {
  if (!failure) sessionStorage.removeItem(routeChunkReloadKey(to.fullPath))
})

const pinia = createPinia()

router.beforeEach(async (to) => {
  if (to.path.startsWith('/public/')) return true
  try {
    const session = await useAuth().ensureUser()
    const userStore = useUserStore(pinia)
    if (!userStore.user) {
      userStore.user = {
        id: session.openId,
        username: session.name,
        avatar: session.avatarUrl,
      } as any
    }
    try {
      const pendingTask = validEvaluationTaskPath(sessionStorage.getItem(PENDING_EVALUATION_TASK_KEY))
      sessionStorage.removeItem(PENDING_EVALUATION_TASK_KEY)
      if (pendingTask && to.path === '/test-ground') return pendingTask
    } catch {
      console.warn('浏览器未开放会话存储，登录后需重新打开任务链接')
    }
    return true
  } catch {
    const taskPath = validEvaluationTaskPath(to.fullPath)
    if (taskPath) {
      try { sessionStorage.setItem(PENDING_EVALUATION_TASK_KEY, taskPath) }
      catch { console.warn('浏览器未开放会话存储，登录后需重新打开任务链接') }
    }
    window.location.href = LOGIN_URL
    return false
  }
})

createApp(App)
  .use(router)
  .use(pinia)
  .mount('#app')
